export enum ProjectTasksViews {
  TABLE = 'table',
  GANTT = 'gantt',
}
